import React from 'react'
import { css } from '@emotion/css'
import {
  Url,
  Importance,
  Metadata,
  Name,
  SizedTooltipList
} from './tooltip-content-pieces'
import { AppUnlicensedLink } from '../link'
import { ApplicationImportance } from '../application-importance'
import { MetadataValue } from '../applications-grid/shared'
import { AgentLanguage } from '../agent-language'
import { Role } from '@contrast-security-inc/base-types'
import { AgentFeature } from '../agent-features'

export function VulnerabilityApplicationTooltipContent({
  organizationID,
  organizationRole,
  hasLicenses,
  showName,
  id,
  name,
  url,
  importance,
  licensed,
  language,
  features,
  onLicense,
  metadata
}: {
  readonly features: AgentFeature[]
  readonly organizationID: string
  readonly organizationRole: Role
  readonly hasLicenses: boolean
  readonly id: string
  readonly name: string
  readonly language: AgentLanguage
  readonly onLicense?: () => void

  readonly url: string
  readonly importance: ApplicationImportance
  readonly licensed: boolean
  readonly showName: boolean
  readonly metadata?: MetadataValue[]
}) {
  return (
    <SizedTooltipList>
      {!licensed && (
        <li
          className={css`
            margin-bottom: 10px;
          `}
        >
          <AppUnlicensedLink
            features={features}
            organizationID={organizationID}
            role={organizationRole}
            archived={false}
            hasLicenses={hasLicenses}
            applicationID={id}
            applicationName={name}
            applicationLanguage={language}
            refresh={
              onLicense
                ? () => {
                    onLicense()
                    return Promise.resolve()
                  }
                : undefined
            }
          />
        </li>
      )}
      {showName && (
        <li>
          <Name name={name} />
        </li>
      )}
      <li>
        <Url url={url} />
      </li>
      <li>
        <Importance importance={importance} />
      </li>
      {metadata && <Metadata values={metadata} />}
    </SizedTooltipList>
  )
}
